import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Layers, Scissors, RotateCw, Image as ImageIcon, ArrowRight, GalleryVerticalEnd, Stamp, FileType } from 'lucide-react';

const tools = [
    {
        path: '/image-to-pdf',
        icon: FileText,
        title: 'Image to PDF',
        description: 'Convert JPG, PNG, and SVG images to PDF with zero quality loss.'
    },
    {
        path: '/merge-pdf',
        icon: Layers,
        title: 'Merge PDF',
        description: 'Combine multiple PDF files into one single document in seconds.'
    },
    {
        path: '/split-pdf',
        icon: Scissors,
        title: 'Extract Pages',
        description: 'Extract specific pages from your PDF or save each page as a separate PDF.'
    },
    {
        path: '/rotate-pdf',
        icon: RotateCw,
        title: 'Rotate PDF',
        description: 'Rotate your PDF pages. You can select specific pages to rotate.'
    },
    {
        path: '/watermark-pdf',
        icon: Stamp,
        title: 'Watermark PDF',
        description: 'Add text or image watermarks to your PDF for security and branding.'
    },
    {
        path: '/pdf-to-jpg',
        icon: ImageIcon,
        title: 'PDF to JPG',
        description: 'Convert each PDF page into a JPG or extract all images contained in a PDF.'
    },
    {
        path: '/rearrange-pdf',
        icon: GalleryVerticalEnd,
        title: 'Rearrange PDF',
        description: 'Sort, delete, and rotate PDF pages. Organise your PDF pages exactly how you want.'
    }
];

const Home = () => {
    return (
        <div className="container animate-fade-in">
            <header style={{ textAlign: 'center', padding: '4rem 0 3rem' }}>
                <h1 style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>
                    Every tool you need to work with PDFs
                </h1>
                <p style={{ fontSize: '1.25rem', maxWidth: '600px', margin: '0 auto' }}>
                    All the tools you need to be more productive and work smarter with documents.
                    100% free and easy to use.
                </p>
            </header>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '2rem',
                padding: '1rem'
            }}>
                {tools.map((tool) => (
                    <Link
                        key={tool.path}
                        to={tool.path}
                        className="glass-card"
                        style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            cursor: 'pointer'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 10px 30px -5px rgba(0, 0, 0, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'var(--shadow)';
                        }}
                    >
                        <div style={{
                            width: '48px',
                            height: '48px',
                            background: 'rgba(99, 102, 241, 0.1)',
                            borderRadius: '1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'var(--primary)',
                            marginBottom: '1.5rem'
                        }}>
                            <tool.icon size={24} />
                        </div>
                        <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.75rem' }}>
                            {tool.title}
                        </h3>
                        <p style={{ marginBottom: '1.5rem', flex: 1 }}>
                            {tool.description}
                        </p>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: 'var(--primary)',
                            fontWeight: 600,
                            gap: '0.5rem'
                        }}>
                            Open Tool <ArrowRight size={16} />
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default Home;
